var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientTwoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99671 1.72728C6.33364 1.72728 5.04934 3.04114 5.04934 4.58279C5.04934 6.12445 6.33364 7.43831 7.99671 7.43831C9.65978 7.43831 10.9441 6.12445 10.9441 4.58279C10.9441 3.04114 9.65978 1.72728 7.99671 1.72728ZM3.36513 4.58279C3.36513 2.01638 5.47405 0 7.99671 0C10.5194 0 12.6283 2.01638 12.6283 4.58279C12.6283 7.1492 10.5194 9.16558 7.99671 9.16558C5.47405 9.16558 3.36513 7.1492 3.36513 4.58279ZM0 13.8387C0 12.1064 1.40293 10.6609 3.2 10.6609H12.8C14.4728 10.6609 16 11.9844 16 13.8387C16 15.3598 15.0302 16.6712 13.6328 17.5586C12.2214 18.4549 10.2709 19 8 19C5.72912 19 3.77859 18.4549 2.36719 17.5586C0.969819 16.6712 0 15.3598 0 13.8387ZM3.2 12.3882C2.30233 12.3882 1.68421 13.0916 1.68421 13.8387C1.68421 14.5491 2.14597 15.3865 3.25386 16.0901C4.34772 16.7847 5.97615 17.2727 8 17.2727C10.0239 17.2727 11.6523 16.7847 12.7461 16.0901C13.854 15.3865 14.3158 14.5491 14.3158 13.8387C14.3158 13.0482 13.6535 12.3882 12.8 12.3882H3.2Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientTwoIcon);
export default __webpack_public_path__ + "static/media/patientTwoIcon.b1b45e5fdceb9ecd219036a54e95be2f.svg";
export { ForwardRef as ReactComponent };